<script lang="ts">
    import PanelistMeetingPage from '@Evaluation/CriteriaSurveys/Pages/PanelistMeetingPage'
    export default PanelistMeetingPage
</script>

<template>
    <div>
        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />

        <template v-if="viewTemplate === 'default'">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div class="container">
                    <a class="btn btn-light mr-auto" v-sanitizedHref="dashboardUrl">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        My Survey
                    </a>
                </div>
            </nav>
            <div class="container" style="padding-top: 80px;">
                <div id="MeetingQuestion" v-if="question">
                    <div style="min-height: 100vh; margin-top: 80px;">
                        <p class="text-center lead" style="font-size: 1.5rem;">
                            In the context of <a class="text-primary" @click="showContextCriterionDetails" title="Show details">{{contextName}}</a>,
                            which criterion is more important: <br />
                            <a class="text-primary" @click="showFirstCriterionDetails" title="Show details">{{firstCriterionName}}</a> or
                            <a class="text-primary" @click="showSecondCriterionDetails" title="Show details">{{secondCriterionName}}</a>?
                        </p>

                        <div style="min-height: 450px;">
                            <div class="PairwiseComparisonEditor">

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="mt1 ItemDetailsBox bg-color-blue3">
                                            <h4>{{firstCriterionName}}</h4>
                                        </div>
                                        <div class="btn-group ItemButton">
                                            <button type="button" class="btn btn-block dropdown-toggle" data-toggle="dropdown" :class="FirstSelected ? 'btn-success' : 'btn-outline-secondary'">
                                                <i class="fa-regular" aria-hidden="true" :class="FirstSelected ? 'fa-square-check' : 'fa-square'"></i>
                                                {{FirstBtnLabel}}
                                            </button>
                                            <div class="dropdown-menu">
                                                <h4 class="dropdown-header">How much more important?</h4>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(2)">Weak (2)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(3)">Moderate (3)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(4)">Moderate + (4)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(5)">Strong (5)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(6)">Strong + (6)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(7)">Very strong (7)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(8)">Very strong + (8)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(9)">Extreme (9)</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div class="mt1 ItemDetailsBox bg-color-red3">
                                            <h4>{{secondCriterionName}}</h4>
                                        </div>
                                        <div class="btn-group ItemButton">
                                            <button type="button" class="btn btn-block dropdown-toggle" data-toggle="dropdown" :class="SecondSelected ? 'btn-success' : 'btn-outline-secondary'">
                                                <i class="fa-regular" aria-hidden="true" :class="SecondSelected ? 'fa-square-check' : 'fa-square'"></i> {{SecondBtnLabel}}
                                            </button>
                                            <div class="dropdown-menu">
                                                <h4 class="dropdown-header">How much more important?</h4>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/2.0)">Weak (2)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/3.0)">Moderate (3)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/4.0)">Moderate + (4)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/5.0)">Strong (5)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/6.0)">Strong + (6)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/7.0)">Very strong (7)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/8.0)">Very strong + (8)</a>
                                                <a class="dropdown-item" @click="handleSavePanelistVoteCommand(1.0/9.0)">Extreme (9)</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12">
                                        <button type="button" class="btn btn-block btn-equal mt1" @click="handleSavePanelistVoteCommand(1.0)" :class="EqualitySelected === true ? 'btn-success' : 'btn-outline-secondary'">
                                            <i class="fa-regular" aria-hidden="true" :class="EqualitySelected === true ? 'fa-square-check' : 'fa-square'"></i>
                                            Equally important (1)
                                        </button>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12">
                                        <div v-if="Value != null" class="text-center">
                                            <button type="button" class="btn btn-link mt1" @click="handleSavePanelistVoteCommand(null)">
                                                <i class="fa fa-times" aria-hidden="true"></i> Clear answer
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div style="margin-top: 30px;">
                                    <h5 style="margin-bottom: 5px;">Comment:</h5>
                                    <textarea rows="5" :value.trim="Comment" @input="handleSavePanelistVoteCommentCommand($event.target.value)" class="form-control" placeholder="Comment..."></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4" style="min-height: 500px;">
                            <div class="PairwiseComparisonVotesBrowserView" v-if="votesEntries">
                                <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                        <a class="nav-link" @click="browserActiveTab = 'votes'" :class="{'active': browserActiveTab === 'votes'}">Votes</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" @click="browserActiveTab = 'summary'" :class="{'active': browserActiveTab === 'summary'}">Chart</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" @click="browserActiveTab = 'comments'" :class="{'active': browserActiveTab === 'comments'}">Comments</a>
                                    </li>
                                </ul>

                                <div class="tab-content">
                                    <div v-if="browserActiveTab === 'votes'" class="tab-pane pt-2" :class="{'active': browserActiveTab === 'votes'}">
                                        <div class="table-responsive">
                                            <table class="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style="border-top: 0;"></th>
                                                        <th class="clearfix" style="min-width: 510px; border-top: 0;">
                                                            <div class="clearfix pull-right" style="width: 85%;">
                                                                <div class="pull-left">{{firstCriterionName}}</div>
                                                                <div class="pull-right">{{secondCriterionName}}</div>
                                                                <div class="text-center" style="margin: 0 auto; width: 50px;">vs</div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style="text-align: center;">
                                                        <td style="text-align: left;">
                                                            <strong>Average ({{AverageDescription}})</strong>
                                                        </td>
                                                        <td style="padding: 0;">
                                                            <ul class="clearfix" style="list-style: none; margin: 0; padding: 0;">
                                                                <li v-for="scaleValue in ScaleView1" :class="GetCssClass(scaleValue, Average)">
                                                                    {{GetScaleItemText(scaleValue, Average)}}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr style="text-align: center;" v-for="voteEntry in VotesEntriesView">
                                                        <td style="text-align: left;">
                                                            {{voteEntry.VotesSourceName}}
                                                        </td>
                                                        <td style="padding: 0;">
                                                            <ul class="clearfix" style="list-style: none; margin: 0; padding: 0;">
                                                                <li v-for="scaleValue in ScaleView1" :class="GetCssClass(scaleValue, voteEntry.Value)">
                                                                    {{GetScaleItemText(scaleValue, voteEntry.Value)}}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                    <div v-if="browserActiveTab === 'summary'" class="tab-pane pt-2" :class="{'active': browserActiveTab === 'summary'}">

                                        <div class="table-responsive">
                                            <table class="table">
                                                <tbody>
                                                    <tr style="text-align: center;" class="bottom noborder">
                                                        <td v-for="v in HistogramValues" style="height: 400px; border: none; padding-top: 20px;">
                                                            <div v-if="v.Count" v-html="v.Count"></div>
                                                            <div :style="{'height': `${v.PercentOfMax}%`}" :class="GetColor(v.Value)" class="bg-color-blue2">&nbsp;</div>
                                                        </td>
                                                    </tr>
                                                    <tr style="text-align: center;">
                                                        <td v-for="hs in HistogramScale" style="width: 6%;">
                                                            {{FormatValue(hs).toFixedIfNeeded(2)}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th :colspan="LeftScaleValuesCount" style="text-align: left;">
                                                            {{firstCriterionName}}
                                                        </th>
                                                        <th style="text-align: center;">vs</th>
                                                        <th :colspan="RightScaleValuesCount" style="text-align: right;">
                                                            {{secondCriterionName}}
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                    </div>

                                    <div v-if="browserActiveTab === 'comments'" class="tab-pane pt-2" :class="{'active': browserActiveTab === 'comments'}">
                                        <blockquote class="blockquote" v-for="c in Comments">
                                            <p class="mb-0">{{c.Comment}}</p>
                                            <footer class="blockquote-footer">{{c.VotesSourceName}}</footer>
                                        </blockquote>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </template>


        <template v-if="viewTemplate === 'connecting'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title"><i class="fa fa-spinner fa-spin"></i> Connecting...</h5>
                        <p class="card-text lead">We are checking if meeting was started by the host.</p><br />
                    </div>
                </div>
            </div>
        </template>

        <template v-if="viewTemplate === 'notStarted'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Meeting is not started</h5>
                        <p class="card-text lead">Please wait for the host to start this meeting.</p><br />
                        <a class="btn btn-secondary" v-sanitizedHref="dashboardUrl">Go to the survey</a>
                    </div>
                </div>
            </div>
        </template>


    </div>
</template>

<style scoped>
    .PairwiseComparisonEditor .btn, .PairwiseComparisonEditor textarea {
        border-radius: 0;
    }

    .PairwiseComparisonEditor .mt1 {
        margin-top: 20px !important;
    }

    .PairwiseComparisonEditor .mt2 {
        margin-top: 40px !important;
    }

    .PairwiseComparisonEditor div.ItemDetailsBox {
        border: 1px solid #ddd;
        border-bottom: 0;
        height: 90px;
        max-height: 90px;
        overflow-y: auto;
        padding: 15px 10px;
        background-color: #f5f5f5;
    }

        .PairwiseComparisonEditor div.ItemDetailsBox h4 {
            padding: 0;
            margin: 0;
            text-align: center;
        }

    .PairwiseComparisonEditor div.ItemButton {
        width: 100%;
        padding: 0px;
    }

        .PairwiseComparisonEditor div.ItemButton a.btn {
            height: 38px;
            padding-top: 8px;
        }

        .PairwiseComparisonEditor div.ItemButton div.dropdown-menu {
            width: 100%;
        }

    .PairwiseComparisonEditor a.btn-equal {
        height: 38px;
        padding-top: 8px;
        width: 100%;
    }

    .PairwiseComparisonEditor a.btn-geometric-mean {
        height: 38px;
        padding-top: 8px;
        width: 100%;
    }


    .PairwiseComparisonVotesBrowserView tr.bottom td {
        vertical-align: bottom !important;
    }


    .PairwiseComparisonVotesBrowserView ul li.EmptyScaleItem {
        display: block;
        float: right;
        min-width: 30px;
        width: 5%;
        padding: 8px;
    }

    .PairwiseComparisonVotesBrowserView ul li.FilledScaleItem {
        display: block;
        float: right;
        min-width: 30px;
        width: 5%;
        padding: 8px;
        color: white;
    }

    .PairwiseComparisonVotesBrowserView ul li.HiddenScaleItem {
        display: none;
    }

    .PairwiseComparisonVotesBrowserView ul li.DoubleFilledScaleItem {
        display: block;
        float: right;
        min-width: 60px;
        width: 10%;
        padding: 8px;
        color: white;
    }


</style>
